package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class NoteQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    title: String?,
    body: String,
    color: String?,
    is_pinned: Long,
    is_favorite: Long,
    tags: String?,
    attachments: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(801_409_593, arrayOf("note"), driver, "Note.sq", "selectAll",
      "SELECT note.id, note.parent_kind, note.parent_id, note.title, note.body, note.color, note.is_pinned, note.is_favorite, note.tags, note.attachments, note.order_index, note.created_at, note.updated_at, note.is_deleted, note.deleted_at, note.synced_at FROM note WHERE is_deleted = 0 ORDER BY is_pinned DESC, updated_at DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectAll(): Query<Note> = selectAll { id, parent_kind, parent_id, title, body, color,
      is_pinned, is_favorite, tags, attachments, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Note(
      id,
      parent_kind,
      parent_id,
      title,
      body,
      color,
      is_pinned,
      is_favorite,
      tags,
      attachments,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    title: String?,
    body: String,
    color: String?,
    is_pinned: Long,
    is_favorite: Long,
    tags: String?,
    attachments: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectById(id: String): Query<Note> = selectById(id) { id_, parent_kind, parent_id,
      title, body, color, is_pinned, is_favorite, tags, attachments, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Note(
      id_,
      parent_kind,
      parent_id,
      title,
      body,
      color,
      is_pinned,
      is_favorite,
      tags,
      attachments,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByParent(
    parent_kind: String,
    parent_id: String?,
    mapper: (
      id: String,
      parent_kind: String,
      parent_id: String?,
      title: String?,
      body: String,
      color: String?,
      is_pinned: Long,
      is_favorite: Long,
      tags: String?,
      attachments: String?,
      order_index: Long,
      created_at: Long,
      updated_at: Long,
      is_deleted: Long,
      deleted_at: Long?,
      synced_at: Long?,
    ) -> T,
  ): Query<T> = SelectByParentQuery(parent_kind, parent_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectByParent(parent_kind: String, parent_id: String?): Query<Note> =
      selectByParent(parent_kind, parent_id) { id, parent_kind_, parent_id_, title, body, color,
      is_pinned, is_favorite, tags, attachments, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Note(
      id,
      parent_kind_,
      parent_id_,
      title,
      body,
      color,
      is_pinned,
      is_favorite,
      tags,
      attachments,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectPinned(mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    title: String?,
    body: String,
    color: String?,
    is_pinned: Long,
    is_favorite: Long,
    tags: String?,
    attachments: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-503_178_176, arrayOf("note"), driver, "Note.sq", "selectPinned",
      "SELECT note.id, note.parent_kind, note.parent_id, note.title, note.body, note.color, note.is_pinned, note.is_favorite, note.tags, note.attachments, note.order_index, note.created_at, note.updated_at, note.is_deleted, note.deleted_at, note.synced_at FROM note WHERE is_pinned = 1 AND is_deleted = 0 ORDER BY updated_at DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectPinned(): Query<Note> = selectPinned { id, parent_kind, parent_id, title, body,
      color, is_pinned, is_favorite, tags, attachments, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Note(
      id,
      parent_kind,
      parent_id,
      title,
      body,
      color,
      is_pinned,
      is_favorite,
      tags,
      attachments,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectFavorite(mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    title: String?,
    body: String,
    color: String?,
    is_pinned: Long,
    is_favorite: Long,
    tags: String?,
    attachments: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_045_866_492, arrayOf("note"), driver, "Note.sq", "selectFavorite",
      "SELECT note.id, note.parent_kind, note.parent_id, note.title, note.body, note.color, note.is_pinned, note.is_favorite, note.tags, note.attachments, note.order_index, note.created_at, note.updated_at, note.is_deleted, note.deleted_at, note.synced_at FROM note WHERE is_favorite = 1 AND is_deleted = 0 ORDER BY updated_at DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectFavorite(): Query<Note> = selectFavorite { id, parent_kind, parent_id, title,
      body, color, is_pinned, is_favorite, tags, attachments, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Note(
      id,
      parent_kind,
      parent_id,
      title,
      body,
      color,
      is_pinned,
      is_favorite,
      tags,
      attachments,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun countByParent(parent_kind: String, parent_id: String?): Query<Long> =
      CountByParentQuery(parent_kind, parent_id) { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectTrash(deleted_at: Long?, mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    title: String?,
    body: String,
    color: String?,
    is_pinned: Long,
    is_favorite: Long,
    tags: String?,
    attachments: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectTrashQuery(deleted_at) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectTrash(deleted_at: Long?): Query<Note> = selectTrash(deleted_at) { id,
      parent_kind, parent_id, title, body, color, is_pinned, is_favorite, tags, attachments,
      order_index, created_at, updated_at, is_deleted, deleted_at_, synced_at ->
    Note(
      id,
      parent_kind,
      parent_id,
      title,
      body,
      color,
      is_pinned,
      is_favorite,
      tags,
      attachments,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at_,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    title: String?,
    body: String,
    color: String?,
    is_pinned: Long,
    is_favorite: Long,
    tags: String?,
    attachments: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_358_163_562, arrayOf("note"), driver, "Note.sq", "selectDirty",
      "SELECT note.id, note.parent_kind, note.parent_id, note.title, note.body, note.color, note.is_pinned, note.is_favorite, note.tags, note.attachments, note.order_index, note.created_at, note.updated_at, note.is_deleted, note.deleted_at, note.synced_at FROM note WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectDirty(): Query<Note> = selectDirty { id, parent_kind, parent_id, title, body,
      color, is_pinned, is_favorite, tags, attachments, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Note(
      id,
      parent_kind,
      parent_id,
      title,
      body,
      color,
      is_pinned,
      is_favorite,
      tags,
      attachments,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    title: String?,
    body: String,
    color: String?,
    is_pinned: Long,
    is_favorite: Long,
    tags: String?,
    attachments: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Note> = selectByIdAnyState(id) { id_,
      parent_kind, parent_id, title, body, color, is_pinned, is_favorite, tags, attachments,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Note(
      id_,
      parent_kind,
      parent_id,
      title,
      body,
      color,
      is_pinned,
      is_favorite,
      tags,
      attachments,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    parent_kind: String,
    parent_id: String?,
    title: String?,
    body: String,
    color: String?,
    is_pinned: Long,
    is_favorite: Long,
    tags: String?,
    attachments: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(2_037_481_477, """
        |INSERT INTO note(
        |    id, parent_kind, parent_id, title, body, color,
        |    is_pinned, is_favorite, tags, attachments, order_index, created_at, updated_at
        |) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 13) {
          bindString(0, id)
          bindString(1, parent_kind)
          bindString(2, parent_id)
          bindString(3, title)
          bindString(4, body)
          bindString(5, color)
          bindLong(6, is_pinned)
          bindLong(7, is_favorite)
          bindString(8, tags)
          bindString(9, attachments)
          bindLong(10, order_index)
          bindLong(11, created_at)
          bindLong(12, updated_at)
        }
    notifyQueries(2_037_481_477) { emit ->
      emit("note")
    }
  }

  public fun update(
    parent_kind: String,
    parent_id: String?,
    title: String?,
    body: String,
    color: String?,
    is_pinned: Long,
    is_favorite: Long,
    tags: String?,
    attachments: String?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_912_539_627, """
        |UPDATE note
        |SET parent_kind = ?, parent_id = ?, title = ?, body = ?, color = ?,
        |    is_pinned = ?, is_favorite = ?, tags = ?, attachments = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 12) {
          bindString(0, parent_kind)
          bindString(1, parent_id)
          bindString(2, title)
          bindString(3, body)
          bindString(4, color)
          bindLong(5, is_pinned)
          bindLong(6, is_favorite)
          bindString(7, tags)
          bindString(8, attachments)
          bindLong(9, order_index)
          bindLong(10, updated_at)
          bindString(11, id)
        }
    notifyQueries(-1_912_539_627) { emit ->
      emit("note")
      emit("note_revision")
    }
  }

  public fun setPinned(
    is_pinned: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_284_302_322, """UPDATE note SET is_pinned = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, is_pinned)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_284_302_322) { emit ->
      emit("note")
    }
  }

  public fun updateText(
    title: String?,
    body: String,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(434_478_306,
        """UPDATE note SET title = ?, body = ?, updated_at = ? WHERE id = ?""", 4) {
          bindString(0, title)
          bindString(1, body)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(434_478_306) { emit ->
      emit("note")
      emit("note_revision")
    }
  }

  public fun setParent(
    parent_kind: String,
    parent_id: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_291_579_680,
        """UPDATE note SET parent_kind = ?, parent_id = ?, updated_at = ? WHERE id = ?""", 4) {
          bindString(0, parent_kind)
          bindString(1, parent_id)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(-1_291_579_680) { emit ->
      emit("note")
    }
  }

  public fun setTags(
    tags: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_234_743_345, """UPDATE note SET tags = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, tags)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_234_743_345) { emit ->
      emit("note")
    }
  }

  public fun setColor(
    color: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(362_383_981, """UPDATE note SET color = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, color)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(362_383_981) { emit ->
      emit("note")
    }
  }

  public fun setAttachments(
    attachments: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_904_986_310,
        """UPDATE note SET attachments = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, attachments)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_904_986_310) { emit ->
      emit("note")
    }
  }

  public fun setFavorite(
    is_favorite: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-86_893_998, """UPDATE note SET is_favorite = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, is_favorite)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-86_893_998) { emit ->
      emit("note")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(134_829_505,
        """UPDATE note SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(134_829_505) { emit ->
      emit("note")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-2_122_203_454,
        """UPDATE note SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""", 2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-2_122_203_454) { emit ->
      emit("note")
    }
  }

  public fun restoreFromTrash(updated_at: Long, id: String) {
    driver.execute(-1_126_104_820,
        """UPDATE note SET is_deleted = 0, updated_at = ? WHERE id = ? AND is_deleted = 1""", 2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-1_126_104_820) { emit ->
      emit("note")
    }
  }

  public fun forget(id: String) {
    driver.execute(1_952_489_273,
        """UPDATE note SET deleted_at = 0 WHERE id = ? AND is_deleted = 1""", 1) {
          bindString(0, id)
        }
    notifyQueries(1_952_489_273) { emit ->
      emit("note")
    }
  }

  public fun purgeTrash(deleted_at: Long?) {
    driver.execute(185_056_409, """
        |DELETE FROM note
        |WHERE is_deleted = 1 AND deleted_at < ?
        |  AND (synced_at IS NULL OR synced_at >= updated_at)
        """.trimMargin(), 1) {
          bindLong(0, deleted_at)
        }
    notifyQueries(185_056_409) { emit ->
      emit("note")
    }
  }

  public fun softDeleteFromRemote(
    `value`: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_970_653_489, """
        |UPDATE note
        |SET is_deleted = 1,
        |    deleted_at = CASE WHEN is_deleted = 1 AND deleted_at = 0 THEN 0 ELSE ? END,
        |    updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 3) {
          bindLong(0, value)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_970_653_489) { emit ->
      emit("note")
    }
  }

  public fun hardDeleteIfSynced(id: String) {
    driver.execute(-797_103_143, """
        |DELETE FROM note
        |WHERE id = ? AND is_deleted = 1
        |  AND (synced_at IS NULL OR synced_at >= updated_at)
        """.trimMargin(), 1) {
          bindString(0, id)
        }
    notifyQueries(-797_103_143) { emit ->
      emit("note")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(-45_232_702, """DELETE FROM note WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(-45_232_702) { emit ->
      emit("note")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(1_337_723_123, """
        |UPDATE note
        |SET synced_at = ?,
        |    deleted_at = CASE WHEN is_deleted = 0 THEN NULL ELSE deleted_at END
        |WHERE id = ? AND updated_at <= ?
        """.trimMargin(), 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(1_337_723_123) { emit ->
      emit("note")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("note", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("note", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-926_065_094,
        """SELECT note.id, note.parent_kind, note.parent_id, note.title, note.body, note.color, note.is_pinned, note.is_favorite, note.tags, note.attachments, note.order_index, note.created_at, note.updated_at, note.is_deleted, note.deleted_at, note.synced_at FROM note WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Note.sq:selectById"
  }

  private inner class SelectByParentQuery<out T : Any>(
    public val parent_kind: String,
    public val parent_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("note", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("note", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT note.id, note.parent_kind, note.parent_id, note.title, note.body, note.color, note.is_pinned, note.is_favorite, note.tags, note.attachments, note.order_index, note.created_at, note.updated_at, note.is_deleted, note.deleted_at, note.synced_at FROM note
    |WHERE parent_kind = ? AND parent_id ${ if (parent_id == null) "IS" else "=" } ? AND is_deleted = 0
    |ORDER BY is_pinned DESC, order_index, updated_at DESC
    """.trimMargin(), mapper, 2) {
      bindString(0, parent_kind)
      bindString(1, parent_id)
    }

    override fun toString(): String = "Note.sq:selectByParent"
  }

  private inner class CountByParentQuery<out T : Any>(
    public val parent_kind: String,
    public val parent_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("note", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("note", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT COUNT(*) FROM note WHERE parent_kind = ? AND parent_id ${ if (parent_id == null) "IS" else "=" } ? AND is_deleted = 0""",
        mapper, 2) {
      bindString(0, parent_kind)
      bindString(1, parent_id)
    }

    override fun toString(): String = "Note.sq:countByParent"
  }

  private inner class SelectTrashQuery<out T : Any>(
    public val deleted_at: Long?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("note", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("note", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_373_191_632,
        """SELECT note.id, note.parent_kind, note.parent_id, note.title, note.body, note.color, note.is_pinned, note.is_favorite, note.tags, note.attachments, note.order_index, note.created_at, note.updated_at, note.is_deleted, note.deleted_at, note.synced_at FROM note WHERE is_deleted = 1 AND deleted_at >= ? ORDER BY deleted_at DESC""",
        mapper, 1) {
      bindLong(0, deleted_at)
    }

    override fun toString(): String = "Note.sq:selectTrash"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("note", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("note", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_382_848_095,
        """SELECT note.id, note.parent_kind, note.parent_id, note.title, note.body, note.color, note.is_pinned, note.is_favorite, note.tags, note.attachments, note.order_index, note.created_at, note.updated_at, note.is_deleted, note.deleted_at, note.synced_at FROM note WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Note.sq:selectByIdAnyState"
  }
}
